<template>
  <div class="detail">
    <div class="content">
      <div v-if="sItem == 1">
        <h2>苏州金螳螂公益慈善基金会党支部简介</h2>
        <div class="text">
          <img style="width: 50%;" src="http://fundation.goldmantis.com:8444/files/news/part11.png"/>
          <p>苏州金螳螂公益慈善基金会党支部成立于2019年4月，隶属于苏州市社会组织党委。党支部在上级党组织的领导下，以党建为中心，带动基金会日常工作的开展，积极探索党组织发挥的载体作用，加强文化建设，促进了基金会内部融合、基金会与社会的和谐，为基金会致力于公益慈善工作提供了强有力的组织保障。</p>
          <p>苏州金螳螂公益慈善基金会党支部以党建和志愿服务相融合的方式，以党建引领志愿服务，以志愿服务响应党建，激发出党组织的凝聚力和号召力，提高党员志愿者参加党组织活动的积极性，激发他们的使命感和责任感，坚定他们热爱党、愿意为党的事业努力奋斗的情感和决心。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'newd',
  data () {
    return {
      sItem: 0
    }
  },
  components: {
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      if(this.$route.params.id){
        this.sItem = this.$route.params.id;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../scss/views/detail';
</style>
